import { AppDispatch } from '../../data/store';
import { WebSocketSessionInfo } from './webSocketService';
import * as userSlice from '../../data/user.slice';

enum UserAccountEventType {
  UserAccountUpdated = 'UserAccountUpdated',
}

type UserAccountDetail = {
  userAccount: any;
};

function updateUserAccount(
  _sessionInfo: WebSocketSessionInfo,
  dispatch: AppDispatch,
  detailType: string,
  { userAccount }: UserAccountDetail,
) {
  switch (detailType) {
    case UserAccountEventType.UserAccountUpdated:
      dispatch(userSlice.setLoggedInUserInfo(userAccount));
      break;
  }
}

export { UserAccountEventType, updateUserAccount };
